<ng-container [formGroup]="formGroup" *ngIf="formArrayName">
    <ng-container [formArrayName]="formArrayName" >
        <ng-container [formGroupName]="formArrayIndex">
            <div class="col-12 col-lg-6 padding-left-0 " [dp-field-visibility]="addressLine1VisibilityKey">
                <mat-form-field >
                    <mat-label>{{addressLine1Label}}</mat-label>
                    <input type="text"
                           formControlName='addressLine1'
                           placeholder="Search for an address"
                           aria-label="Search for an address"
                           #trigger="matAutocompleteTrigger"
                           matInput
                           (input)="searchAddresses($event)"
                           [maxlength]="addressLine1MaxLength"
                           [matAutocomplete]="auto">
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="dataSelectedAddress($event.option.value, trigger)">
                    <mat-option *ngFor="let option of addressSuggestions" [value]="option">
                        {{option.description}}
                        <span style="float:right">{{option.moreAddressIndicator}}</span>
                    </mat-option>
                </mat-autocomplete>
            </div>
            <div class="col-12 col-lg-6 padding-left-0 " [dp-field-visibility]="addressLine2VisibilityKey">
                <mat-form-field  >
                    <mat-label>Address 2</mat-label>
                    <input matInput formControlName="addressLine2" [maxlength]="addressLine2MaxLength">
                    <mat-error>This field is required</mat-error>
                </mat-form-field>

            </div>
            <div class="row col-12 padding-left-0 padding-right-0">
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="cityVisibilityKey">
                    <mat-form-field >
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" [maxlength]="cityMaxLength">
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="provinceCodeVisibilityKey">
                    <mat-form-field >
                        <mat-label>Province</mat-label>
                        <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                        <select matNativeControl formControlName="provinceCode" #provinceSelect aria-label="Select a province">
                            <option *ngFor="let option of provinceOptions" [value]="option.value">{{ option.name }}</option>
                        </select>
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="postalCodeVisibilityKey">
                    <mat-form-field >
                        <mat-label>Postal Code</mat-label>
                        <input matInput formControlName="postalCode" [pattern]="postlCodePatern" [placeholder]="postalCodeExample">
                        <mat-error>Invalid Postal Code {{postalCodeExample}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="countryVisibilityKey">
                    <mat-form-field  >
                        <mat-label>Country</mat-label>
                        <!-- The native <select> offers the best accessibility as it is supported directly by screen-readers  -->
                        <select matNativeControl formControlName="country" #countrySelect aria-label="Select a country">
                            <option *ngFor="let option of countryOptions" [value]="option.value">{{option.name }}</option>
                        </select>
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
    </ng-container>

</ng-container>

<ng-container [formGroup]="formGroup" *ngIf="!formArrayName">
        <ng-container [formGroupName]="formGroupName">
            <div class="col-12 col-lg-6 padding-left-0" [dp-field-visibility]="addressLine1VisibilityKey">
                <mat-form-field >
                    <mat-label>{{addressLine1Label}}</mat-label>
                    <input type="text"
                           formControlName='addressLine1'
                           placeholder="Search for an address"
                           aria-label="Search for an address"
                           #trigger="matAutocompleteTrigger"
                           matInput
                           (input)="searchAddresses($event)"
                           [maxlength]="addressLine1MaxLength"
                           [matAutocomplete]="auto">
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="dataSelectedAddress($event.option.value , trigger)" >
                    <mat-option *ngFor="let option of addressSuggestions" [value]="option">
                        {{option.description}}  <span style="float:right">{{option.moreAddressIndicator}}</span>
                    </mat-option>
                </mat-autocomplete>
            </div>
            <div class="col-12 col-lg-6 padding-left-0" [dp-field-visibility]="addressLine2VisibilityKey">
                <mat-form-field >
                    <mat-label>Address 2</mat-label>
                    <input matInput formControlName="addressLine2" [maxlength]="addressLine2MaxLength">
                </mat-form-field>

            </div>
            <div class="row col-12 padding-left-0 padding-right-0">
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="cityVisibilityKey">
                    <mat-form-field  >
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" [maxlength]="cityMaxLength">
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="provinceCodeVisibilityKey">
                    <mat-form-field  >
                        <mat-label>Province</mat-label>
                        <select matNativeControl formControlName="provinceCode" aria-label="Select a province">
                            <option *ngFor="let option of provinceOptions" [value]="option.value">{{ option.name }}</option>
                        </select>
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="postalCodeVisibilityKey">
                    <mat-form-field  >
                        <mat-label>Postal Code</mat-label>
                        <input matInput formControlName="postalCode" [pattern]="postlCodePatern" [placeholder]="postalCodeExample">
                        <mat-error>Invalid Postal Code {{postalCodeExample}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 padding-left-0" [dp-field-visibility]="countryVisibilityKey">
                    <mat-form-field  >
                        <mat-label>Country</mat-label>
                        <select matNativeControl formControlName="country" aria-label="Select a country">
                            <option *ngFor="let option of countryOptions" [value]="option.value">{{option.name }}</option>
                        </select>
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
            </div>

        </ng-container>

</ng-container>
